import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmpf2ajrh1g/layouts/custom.vue").then(m => m.default || m))
}